import { render } from "./NextPageIcon.vue?vue&type=template&id=40f4d049"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/NextPageIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40f4d049"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40f4d049', __exports__)) {
    api.reload('40f4d049', __exports__)
  }
  
  module.hot.accept("./NextPageIcon.vue?vue&type=template&id=40f4d049", () => {
    api.rerender('40f4d049', render)
  })

}


export default __exports__